import config from '../../config/config';

import deleteRequest from './base/delete';
import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the Total Consumer Card
   */
  fetchTotalConsumerCard: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/total-end-consumer-cards`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Total Consumer Card
   */
  fetchTotalChartApi: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/total-revenue-power-consumed-session-reports`,
      {
        ...parameters,
      },
    );
  },

  /**
   * Fetch the Basic Information
   */
  fetchBasicInformation: (userCustomId: string): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/basic-information/${userCustomId}`,
    );
  },

  /**
   * Fetch the Basic Information
   */
  fetchEndConsumerStatus: (): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-end-consumer-status`,
    );
  },

  /**
   * Fetch the Revenue Power Session
   */
  fetchRevenuePowerSessions: (userCustomId: string, data: any): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/revenue-power-sessions-by-user/${userCustomId}`,
      {
        ...data,
      },
    );
  },
  /**
   * Fetch the Basic Information
   */
  fetchNotifications: (userCustomId: string): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/notifications/${userCustomId}`,
    );
  },
  /**
   * Fetch the Basic Information
   */
  fetchOtps: (userCustomId: string): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-otps/${userCustomId}`,
    );
  },
  /**
   * Fetch the Schedules list with pagination
   */
  fetchSchedules: (userCustomId: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/personal-schedules/${userCustomId}`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch personal schedules Export Data
   */
  fetchSchedulesExportData: (userCustomId: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/personal-schedules-export/${userCustomId}`,
      {
        ...parameters,
      },
    );
  },

  /**
   * Fetch personal schedules Upcoming filters
   */
  fetchSchedulesUpcomingFilters: (
    userCustomId: string,
    query: QueryParameters = {},
  ): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/personal-schedules-filter/${userCustomId}`,
      {
        ...parameters,
        status: 'upcoming',
      },
    );
  },

  /**
   * Fetch personal schedules Completed filters
   */
  fetchSchedulesCompletedFilters: (
    userCustomId: string,
    query: QueryParameters = {},
  ): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/personal-schedules-filter/${userCustomId}`,
      {
        ...parameters,
        status: 'completed',
      },
    );
  },

  /**
   * Fetch the Reservations list with pagination
   */
  fetchReservationsList: (userCustomId: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/commercial-schedules/${userCustomId}`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch commercial schedules filters
   */
  fetchReservationsFilters: (userCustomId: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/commercial-schedules-filter/${userCustomId}`,
      {
        ...parameters,
      },
    );
  },

  /**
   * Fetch the Reservations list with pagination
   */
  fetchChargeSessionList: (userCustomId: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-charging-transactions/${userCustomId}`,
      {
        ...parameters,
      },
    );
  },

  /**
   * Fetch commercial charge session filters
   */
  fetchChargeSessionCommercialFilters: (
    userCustomId: string,
    query: QueryParameters = {},
  ): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-charging-transactions-filter/${userCustomId}`,
      {
        ...parameters,
        type: 'commercial',
      },
    );
  },

  /**
   * Fetch personal charge session filters
   */
  fetchChargeSessionPersonalFilters: (
    userCustomId: string,
    query: QueryParameters = {},
  ): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-charging-transactions-filter/${userCustomId}`,
      {
        ...parameters,
        type: 'personal',
      },
    );
  },

  /**
   * Fetch the Guest Free list with pagination
   */
  fetchGuestFreeChargingList: (userCustomId: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-guest-free-charging-schedules/${userCustomId}`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch guest free charging filters
   */
  fetchGuestFreeChargingFilters: (
    userCustomId: string,
    query: QueryParameters = {},
  ): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-guest-free-charging-schedules-filter/${userCustomId}`,
      {
        ...parameters,
        type: 'personal',
      },
    );
  },

  /**
   * Fetch the Guest Free list with pagination
   */
  fetchTransactionsPaymentList: (
    userCustomId: string,
    query: QueryParameters = {},
  ): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-end-consumer-payment-transactions/${userCustomId}`,
      {
        ...parameters,
      },
    );
  },

  /**
   * Fetch transactions payment filters
   */
  fetchTransactionsPaymentFilters: (
    userCustomId: string,
    query: QueryParameters = {},
  ): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-end-consumer-payment-transactions-filter/${userCustomId}`,
      {
        ...parameters,
        type: 'personal',
      },
    );
  },

  /**
   * Fetch the Vehicle list with pagination
   * @param {string} userCustomId - The custom ID of the user
   * @param {object} query - The query parameters
   * @returns {Promise<any>} - The response from the API
   */
  fetchVehicleList: (userCustomId: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-end-consumer-vehicle-list/${userCustomId}`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Set the primary vehicle
   * @param userCustomId - The custom ID of the user
   * @param data - The data to be sent to the API
   * @returns {Promise<any>} - The response from the API
   */
  setVehiclePrimary: (userCustomId: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return patchRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-end-consumer-vehicle-list/${userCustomId}`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Delete the vehicle
   * @param userCustomId - The custom ID of the user
   * @param data - The data to be sent to the API
   * @returns {Promise<any>} - The response from the API
   */
  deleteVehicle: (userCustomId: string, vehicleId: string): Promise<any> => {
    return deleteRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-end-consumer-vehicle-list/${userCustomId}/${vehicleId}`,
    );
  },

  /**
   * Fetch the Basic Information
   */
  fetchFavoriteStations: (userCustomId: string): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-end-consumer-favorite-stations/${userCustomId}`,
    );
  },
  /**
   * Fetch the Basic Information
   */
  fetchPersonalChargers: (userCustomId: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-end-consumer-personal-chargers/${userCustomId}`,
      {
        ...parameters,
      },
    );
  },

  /**
   * Fetch the Basic Information
   */
  fetchWalletHistory: (userCustomId: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-end-consumer-wallet-history/${userCustomId}`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Basic Information
   */
  fetchSessionList: (userCustomId: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-end-consumer-charging-session-list/${userCustomId}`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the Payment Cards list with pagination
   * @param userCustomId - The custom ID of the user
   * @param query - The query parameters
   * @returns {Promise<any>} - The response from the API
   */
  fetchPaymentMethods: (userCustomId: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-end-consumer-payment-methods/${userCustomId}`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Set the primary payment method
   * @param userCustomId - The custom ID of the user
   * @param query - The query parameters
   * @returns {Promise<any>} - The response from the API
   */
  setPrimaryPaymentMethod: (userCustomId: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return postRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-end-consumer-payment-methods/${userCustomId}`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch charging session info
   */
  fetchChargingTransaction: (id: string): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/charging-transaction/charging-session-info/${id}`,
    );
  },
  /**
   * Charging session export
   * @param userCustomId - The custom ID of the user
   * @param query - The query parameters
   * @returns {Promise<any>} - The response from the API
   */
  chargingSessionExport: (userCustomId: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-charging-transactions-export/${userCustomId}`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Reservation export
   * @param userCustomId - The custom ID of the user
   * @param query - The query parameters
   * @returns {Promise<any>} - The response from the API
   */
  reservationExport: (userCustomId: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/commercial-schedules-export/${userCustomId}`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Guest charging export
   * @param userCustomId - The custom ID of the user
   * @param query - The query parameters
   * @returns {Promise<any>} - The response from the API
   */
  guestChargingExport: (userCustomId: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-guest-free-charging-schedules-export/${userCustomId}`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Transaction export
   * @param userCustomId - The custom ID of the user
   * @param query - The query parameters
   * @returns {Promise<any>} - The response from the API
   */
  transactionExport: (userCustomId: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-end-consumer-payment-transactions-export/${userCustomId}`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Delete the payment method
   * @param userCustomId - The custom ID of the user
   * @param cardId - The ID of the card
   * @returns {Promise<any>} - The response from the API
   */
  deletePaymentMethod: (userCustomId: string, cardId: string): Promise<any> => {
    return deleteRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-end-consumer-payment-methods/${userCustomId}/${cardId}`,
    );
  },

  /**
   * Fetch payment details side panel
   */
  fetchPaymentDetailsSidePanel: (userCustomId: string): Promise<any> => {
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-end-consumer-transaction-details/${userCustomId}`,
    );
  },

  /**
   * Fetch basic profile
   */
  fetchBasicProfile: (userCustomId: string): Promise<any> => {
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/consumer/${userCustomId}`, {});
  },

  /**
   * Edit basic information
   */
  editBasicInformation: (userCustomId: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return patchRequest(`${config.accountApiUrl}api/super-admin/v1/consumer/${userCustomId}`, {
      ...parameters,
    });
  },
  /**
   * Fetch active session
   */
  fetchActiveSession: (userCustomId: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/super-admin/v1/end-consumer/get-active-session/${userCustomId}`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Remote stop transaction
   */
  remoteStopTransaction: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return postRequest(`${config.ocppApiUrl}api/ocpp16/v1/super-admin/remote-stop-transaction`, {
      ...parameters,
    });
  },
  /**
   * top up money to an end consumer's wallet
   * @param endConsumerId
   * @param query
   * @returns
   */
  topUpWallet: (endConsumerId: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return postRequest(
      `${config.transactionApiUrl}api/super-admin/v1/wallet-management/top-up/${endConsumerId}`,
      {
        ...parameters,
      },
    );
  },
};
